import BaseUser from "./BaseUser";

class Login extends BaseUser {

    constructor() {
        super();
    }

    async getData() {
	    return this.fullFetch(this.getResource(), 'get')
    }

    async editData(input) {
	    return this.fullFetch(this.getResource(), 'put', {data: input})
    }

    async into(data) {
        return this.fullFetch(this.getResource(), "post", {data: data})
    }

    getResource() {
        return 'login';
    }

}


export default Login;